import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { IdleService } from './core/services/idle.service';
import { slideInOutAnimation } from './shared/router.animations';
import { DirectoryService } from './room-directory/services/directory-service.service';
import { TodayEventsService } from './today-events/services/today-events.service';
import { Branch } from './shared/enums/branch.enum';
import { faHome } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [slideInOutAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit {

  faHome = faHome;

  constructor(
    private router: Router,
    private idleService: IdleService,
    private directoryService: DirectoryService,
    private eventService: TodayEventsService
  ) { }

  private idleSubscription$: Subscription;

  ngOnInit(): void {
    this.directoryService.getAllExecs().subscribe();
    this.directoryService.getAllHouseCommittees().subscribe();
    this.directoryService.getAllSenateCommittees().subscribe();
    this.directoryService.getAllJointCommittees().subscribe();
    this.directoryService.getAllOthers().subscribe();
    this.directoryService.getMembers(Branch.senate).subscribe();
    this.directoryService.getMembers(Branch.house).subscribe();
    this.eventService.getAdminEvents().subscribe();
    this.eventService.getHearings().subscribe();
    this.eventService.getSpecialEvents().subscribe();
    this.eventService.getSessions().subscribe();
    this.eventService.getTodayHearings().subscribe();
    this.eventService.getTodaySpecialEvents().subscribe();
    this.eventService.getTodaySessions().subscribe();
  }

  onRouterOutletActivate(outlet: RouterOutlet) {
    if (this.isIdleRedirectEnabled(outlet)) {
      this.startIdleRedirect();
    }
    else {
      this.stopIdleRedirect();
    }
  }

  onRouterOutletDeactivate() {
    this.stopIdleRedirect();
  }

  private isIdleRedirectEnabled(outlet: RouterOutlet): boolean {
    return outlet.activatedRouteData?.['disableIdleRedirect'] !== true;
  }

  private startIdleRedirect(): void {
    if (!this.idleSubscription$) {
      this.idleSubscription$ = this.idleService.idleDetected$.subscribe(() => {
        this.router.navigate(['']);
      });
    }
  }
  private stopIdleRedirect(): void {
    if (this.idleSubscription$) {
      this.idleSubscription$.unsubscribe();
      this.idleSubscription$ = null;
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet.isActivated
      ? outlet.activatedRouteData['transitionState'] || outlet.activatedRoute
      : 'closed';
  }

  hasRoute(route: string) {
    route = "/" + route;
    return this.router.url === route;
  }

  home() {
    if (this.router.url === '/') {
      return true;
    } else {
      return false;
    }
  }
}
